var _g, _path, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutlook = function SvgOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2306_173508)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#276BA6",
    stroke: "#fff",
    strokeWidth: 1.427,
    d: "m21.014 3.087 12.16 7.04a2.77 2.77 0 0 1 1.382 2.398v14.08a2.77 2.77 0 0 1-1.381 2.399l-12.161 7.04a2.75 2.75 0 0 1-2.759 0l-12.161-7.04a2.77 2.77 0 0 1-1.38-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.759 0Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2306_173508",
    width: 16,
    height: 16,
    x: 12,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 12h15.537v15.84H12z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#mask0_2306_173508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 26.026V13.6l9.119-1.6v15.843zm3.669-6.117c0 .944.456 1.709 1.02 1.709.563 0 1.02-.765 1.02-1.71 0-.943-.457-1.708-1.02-1.708-.564 0-1.02.765-1.02 1.709m-1.077.004c0-1.593.95-2.884 2.122-2.884s2.12 1.291 2.12 2.884-.949 2.884-2.12 2.884-2.121-1.291-2.121-2.884M21.686 19.544v4.167h5.156s.755-.106.692-1.113l.004-5.445-3.777 2.6s-1.07.877-2.075-.21"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.76 15.032h5.185s.61-.044.61.659l-4.687 3.305-1.108-.747z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2306_173508",
    width: 38.83,
    height: 42.685,
    x: 0.219,
    y: 0.113,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2306_173508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2306_173508",
    result: "shape"
  })))));
};
export default SvgOutlook;